import { CompanyIDs } from '@/core/companyComponents';

const MAGENTA_TOOLTIP = [
    '<b>Πώς να αποκτήσεις κωδικό MAGENTA MOMENTS;</b> </br>',
    'Μπες στην εφαρμογή COSMOTE TELEKOM ή στο WHAT’S UP και απόκτησε εντελώς δωρεάν τον κωδικό MAGENTA MOMENTS.</br>',
    '<a href="https://moosend-template-files.s3.eu-west-1.amazonaws.com/CompanyFiles/ANYTIME/MAGENTA+MOMENTS-+%CE%8C%CF%81%CE%BF%CE%B9+%26+%CE%A0%CF%81%CE%BF%CF%8B%CF%80%CE%BF%CE%B8%CE%AD%CF%83%CE%B5%CE%B9%CF%82.pdf" target="_blank" rel="noopener noreferrer">Όροι και Προϋποθέσεις</a>',
].join('<br/>');

const VODAFONE_TOOLTIP = [
    '<b>Τρόποι για να λάβεις κωδικό Vodafone Thank you</b> </br>',
    '1. Μέσω της εφαρμογής My Vodafone',
    '2. Στέλνοντας Eurolife στο 54646 </br>',
    '<em>Χρέωση ανά κωδικό 0,20€</em>'
].join('<br/>');

const getPrimaryProduct = (selectedProduct) => {
    const multiproduct = selectedProduct?.payload?.multiproduct;
    const primaryProductId = multiproduct?.attributes?.primaryProduct;

    if (!primaryProductId) {
        return null;
    }

    return multiproduct?.products?.find((product) => product?._id === primaryProductId) ?? null;
};

export const resolveCheckoutDiscountMandatory = (selectedProduct) => {
    if (!selectedProduct) {
        return false;
    }

    const primaryProduct = getPrimaryProduct(selectedProduct);
    const productName = primaryProduct?.name ?? '';

    return productName.includes('VODAFONE');
};

export const resolveCheckoutDiscountTooltip = (selectedProduct) => {
    if (!selectedProduct) {
        return '';
    }

    const primaryProduct = getPrimaryProduct(selectedProduct);
    const vendorId = primaryProduct?.vendor?.guid ?? '';

    if (vendorId === CompanyIDs.ANYTIME) {
        return MAGENTA_TOOLTIP;
    }

    if (vendorId === CompanyIDs.EUROLIFE) {
        return VODAFONE_TOOLTIP;
    }

    return '';
};

export default resolveCheckoutDiscountTooltip;
